export default __webpack_public_path__ + "static/media/free-gift-placeholder.b6c0c305.jpeg";